"use client";
import {
  MenubarContextProvider,
  MenubarScopedContextProvider,
  useMenubarContext,
  useMenubarProviderContext,
  useMenubarScopedContext
} from "./WSQNIDGC.js";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./WENSINUV.js";
import {
  HovercardContextProvider,
  HovercardScopedContextProvider
} from "./CTQR3VDU.js";
import {
  createStoreContext
} from "./HKOOKEDE.js";

// src/menu/menu-context.tsx
import { createContext } from "react";
var menu = createStoreContext(
  [CompositeContextProvider, HovercardContextProvider],
  [CompositeScopedContextProvider, HovercardScopedContextProvider]
);
var useMenuContext = menu.useContext;
var useMenuScopedContext = menu.useScopedContext;
var useMenuProviderContext = menu.useProviderContext;
var MenuContextProvider = menu.ContextProvider;
var MenuScopedContextProvider = menu.ScopedContextProvider;
var useMenuBarContext = useMenubarContext;
var useMenuBarScopedContext = useMenubarScopedContext;
var useMenuBarProviderContext = useMenubarProviderContext;
var MenuBarContextProvider = MenubarContextProvider;
var MenuBarScopedContextProvider = MenubarScopedContextProvider;
var MenuItemCheckedContext = createContext(
  void 0
);

export {
  useMenuContext,
  useMenuScopedContext,
  useMenuProviderContext,
  MenuContextProvider,
  MenuScopedContextProvider,
  useMenuBarContext,
  useMenuBarScopedContext,
  useMenuBarProviderContext,
  MenuBarContextProvider,
  MenuBarScopedContextProvider,
  MenuItemCheckedContext
};
